export default function (store) {
    let startPosition, initialTop, verticalMotion
    const threshold = 100
    const closeSliderGrip = document.querySelector('[draggable="true"]')
    const overlayContent = document.querySelector('.kb-page-overlay__content')

    closeSliderGrip.addEventListener('touchstart', (e) => {
        initialTop =
            initialTop ||
            +getComputedStyle(overlayContent)
                .getPropertyValue('top')
                .replace('px', '')
        startPosition = 0
    })

    closeSliderGrip.addEventListener('touchmove', (e) => {
        e.preventDefault()
        e.stopPropagation()

        verticalMotion = e.touches[0].clientY

        if (startPosition && startPosition < verticalMotion) {
            overlayContent.style.top =
                verticalMotion - startPosition + initialTop + 'px'
            overlayContent.style.transitionDuration = '1ms'
        } else {
            startPosition = verticalMotion
        }
    })

    closeSliderGrip.addEventListener('touchend', () => {
        if (startPosition + threshold < verticalMotion) {
            store.commit('main/close_page_overlay')
        }
        overlayContent.style.top = ''
        overlayContent.style.transitionDuration = ''
    })
}
